import { toast } from 'react-toastify';
import { STATUS_BADGE } from '../../../../constants/fundings';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useEnv } from '../../../../context/env-context';
import { useAuth } from '../../../../hooks/useAuth';
import { makeRequest } from '../../../../utils/makeRequest';
import { memo } from 'react';

function FundingStatusForm({ fundingId, fundingStatus, setSpinner, getFunding }) {
  const { apiOriginFunding } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const closeClosingFunding = async () => {
    if (window.confirm('Are you sure?')) {
      setSpinner(true);
      const token = await getAccessTokenSilently();

      if (!token) {
        return;
      }

      const config = {
        token,
        url: `${apiOriginFunding}/close_closing_funding`,
        method: 'POST',
        data: JSON.stringify({ fundingId }),
      };

      try {
        await makeRequest(config);
        await getFunding(fundingId);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setSpinner(false);
      }
    }
  };

  const toggleDefault = async reopenFunding => {
    if (window.confirm('Are you sure?')) {
      setSpinner(true);
      const token = await getAccessTokenSilently();

      if (!token) {
        return;
      }

      const config = {
        token,
        url: `${apiOriginFunding}/${reopenFunding ? 'reopen' : 'set_default'}`,
        method: 'POST',
        data: JSON.stringify({ fundingId }),
      };

      try {
        await makeRequest(config);
        await getFunding(fundingId);

        toast.success(
          reopenFunding
            ? 'Repayment status successfully reopened'
            : 'Repayment status successfully set to DEFAULT',
        );
      } catch (error) {
        toast.error(error.message);
      } finally {
        setSpinner(false);
      }
    }
  };

  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Status:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        {STATUS_BADGE[fundingStatus] && (
          <Badge className="bo-badge" bg={STATUS_BADGE[fundingStatus]?.color}>
            {STATUS_BADGE[fundingStatus]?.text}
          </Badge>
        )}
        {fundingStatus === 'CLOSING' && (
          <Button className="bo-link mb-0 ms-3 p-0" onClick={closeClosingFunding}>
            Close
          </Button>
        )}
        <Button
          className="bo-link mb-0 ms-3 p-0"
          onClick={() => toggleDefault(fundingStatus === 'DEFAULT' || fundingStatus === 'CLOSED')}
        >
          {fundingStatus === 'DEFAULT' || fundingStatus === 'CLOSED' ? 'Re-open' : 'Set as Default'}
        </Button>
      </Col>
    </>
  );
}

export default memo(FundingStatusForm);
